import Vue from 'vue'
import {Pagination} from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import jquery from "jquery";
import router from "./router/router.js";
import api from './http.js'
// axios.defaults.baseURL = 'http://jhsyxh.demo.guizhifeng.com/'
// api.baseURL = 'http://jhsyxh.demo.guizhifeng.com'

// import bootstrap from "bootstrap";
import 'bootstrap/dist/css/bootstrap.css'
import './assets/css/flexslider.css';
import './assets/css/share.min.css';
import './assets/css/owl.carousel.css';
import './assets/css/common.css';
import './assets/css/media-1.css';
import App from './App.vue'
// const icoURL = 'http://jhsyxh.demo.guizhifeng.com/'
const icoURL = 'https://www.sxsjhsyxh.org.cn/'
const imgURL = 'https://www.sxsjhsyxh.org.cn'
Vue.prototype.icoURL = icoURL
Vue.prototype.imgURL = imgURL
Vue.config.productionTip = false
Vue.prototype.axios = api
Vue.use(Pagination)

//引入
import hHeader from './components/hHeader'
import foot from './components/foot'
import list from './components/list'
import hmenu from './components/hmenu'
import erjiTitle from './components/erjiTitle'

//注册为全局组件
Vue.component('hHeader',hHeader)
Vue.component('foot',foot)
Vue.component('list',list)
Vue.component('hmenu',hmenu)
Vue.component('erjiTitle',erjiTitle)






new Vue({
	router,
  render: h => h(App),
}).$mount('#app')
